export default "__VITE_ASSET__CRKIS2$s__"